import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const addJob = (orgId: number, job: Record<string, any>, copyFromJobId: number | null) =>
  createGenericDispatcher<{ job: Job; jobDetails: JobDetails; jobSummary: JobSummary }>({
    name: 'ADD_JOB',
    loadFunction: () =>
      Api.post(`/org/${orgId}/jobs`, {
        body: JSON.stringify({
          job,
          copyFromJobId,
        }),
      }),
    args: { orgId, job, copyFromJobId },
  });
